import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Dropzone from 'react-dropzone'
// import 'dropzone/dist/min/dropzone.min.css';
import '../../../assets/css/dropzone.css'
import { attachmentsService } from '../../../_services/attachments.service'
import { productsService } from '../../../_services/products.service'
import MySweetAlert from '../../Shared/MySweetAlert'
import { FiTrash2 } from 'react-icons/fi'
import config from '../../../config'

import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="row">
        <div className="form-inline">
          <Upload
            productId={values.id}
            onChange={() => {
              setFieldValue('uploaded', true)
            }}
          />
          <br />
          <ImageList productId={values.id} uploaded={values.uploaded} />
        </div>
      </div>
    </div>
  </div>
)

class Upload extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      data: [],
      productId: this.props.productId
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.productId && nextProps.productId !== this.state.productId) {
      this.setState({ productId: nextProps.productId })
    }
  }

  onDrop(acceptedFiles) {
    if (acceptedFiles.length === 0) {
      return
    }

    let fd = new FormData()
    acceptedFiles.forEach(file => {
      fd.append('Files', file)
    })

    attachmentsService
      .setProductImages(this.state.productId, fd)
      .then(res => {
        toastr.success('تصاویر با موفقیت آپلود شد')
        this.props.onChange()
      })
      .catch(error => {
        // console.log(error)
      })
  }

  onDragOver(ev) {
    ev.preventDefault()
    var data = ev.dataTransfer.items
    for (var i = 0; i < data.length; i += 1) {
      if (data[i].kind === 'file' && data[i].type.match('^image/')) {
        // Drag data item is an image file
        //var f = data[i].getAsFile();
        this.setState({ isDragActive: true, IsDropTypeError: false })
      } else {
        this.setState({ isDragActive: false, IsDropTypeError: true })
      }
    }
  }

  render() {
    return (
      <div>
        <Dropzone
          onDrop={e => this.onDrop(e)}
          accept="image/jpeg, image/png, image/gif"
          onDragOver={e => this.onDragOver(e)}>
          {({ getRootProps, getInputProps, isDragActive }) => {
            return (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                {isDragActive ? (
                  !this.state.IsDropTypeError ? (
                    <div className="filepicker dropzone dz-clickable trueType">
                      <div
                        data-filetype=".jpg"
                        className="filepicker-file-icon"
                      />
                      <div
                        data-filetype=".png"
                        className="filepicker-file-icon"
                      />
                      <div
                        data-filetype=".gif"
                        className="filepicker-file-icon"
                      />
                      <div className="dz-message needsclick">
                        <span>تصاویر را به اینجا کشیده و رها کنید</span>
                      </div>
                    </div>
                  ) : (
                    <div className="filepicker dropzone dz-clickable error">
                      <div
                        data-filetype=".jpg"
                        className="filepicker-file-icon"
                      />
                      <div
                        data-filetype=".png"
                        className="filepicker-file-icon"
                      />
                      <div
                        data-filetype=".gif"
                        className="filepicker-file-icon"
                      />
                      <div className="dz-message needsclick">
                        <span>این نوع از فایل پشتیبانی نمیشود</span>
                      </div>
                    </div>
                  )
                ) : (
                  <div className="filepicker dropzone dz-clickable">
                    <div
                      data-filetype=".jpg"
                      className="filepicker-file-icon"
                    />
                    <div
                      data-filetype=".png"
                      className="filepicker-file-icon"
                    />
                    <div
                      data-filetype=".gif"
                      className="filepicker-file-icon"
                    />
                    <div className="dz-message needsclick">
                      <span>برای آپلود تصاویر اینجا کلیک کنید</span>
                    </div>
                  </div>
                )}
              </div>
            )
          }}
        </Dropzone>
      </div>
    )
  }
}

class ImageList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      data: [],
      confirmDeleteShow: false,
      productId: this.props.productId,
      imagesCount: this.props.images ? this.props.images.length : 0
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.productId && nextProps.productId !== this.state.productId) {
      this.setState({ productId: nextProps.productId }, () => {
        this.getData()
      })
    }
    // // console.log(nextProps);

    if (nextProps.uploaded) {
      this.getData()
    }
  }

  getData = async () => {
    await productsService
      .getImages(this.state.productId)
      .then(res => {
        // console.log(res.data);
        this.setState({ data: res.data })
      })
      .catch(error => {
        // console.log(error);
      })
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    let _photos = arrayMove(this.state.data, oldIndex, newIndex)

    this.setState({
      data: _photos
    })

    var ids = []
    _photos.map(item => ids.push(item.id))
    // console.log(_photos);

    attachmentsService
      .ChangeOrder(this.state.productId, ids)
      .then(res => {
        this.setState({ data: res.data })
        toastr.success('تغییر ترتیب نمایش', 'اطلاعات با موفقیت بروزرسانی شد')
        // this.getData();
      })
      .catch(error => {
        // console.log(error)
      })
  }

  shouldCancelStart = event => {
    // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
    const disabledElements = [
      'input',
      'textarea',
      'select',
      'option',
      'button',
      'i'
    ]

    if (
      disabledElements.indexOf(event.target.tagName.toLowerCase()) !==
      '00000000-0000-0000-0000-000000000000'
    ) {
      // Return true to cancel sorting
      return true
    }

    return false
  }

  handleDelete = e => {
    this.setState({
      confirmDeleteShow: true,
      deletableId: e
    })
  }

  handleConfirmDelete() {
    this.setState({ confirmDeleteShow: false })

    attachmentsService
      .delete(this.state.deletableId)
      .then(res => {
        this.getData()
      })
      .catch(error => {
        // console.log(error);
      })
  }

  render() {
    const SortableItem = SortableElement(({ value }) => (
      <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2 ">
        <div className="product-image-container">
          <img
            src={config.uploadsUrl + value.imageUrl}
            alt=""
            className="img-responsive"
          />

          <div className="settings">
            <div className="card3-actions text-center">
              <button
                onClick={() => this.handleDelete(value.id)}
                className="btn btn-sm btn-danger btn-simple delete-btn">
                <FiTrash2 className="mdi" />
              </button>
            </div>
          </div>
        </div>
      </div>
    ))

    const SortableList = SortableContainer(({ items }) => {
      return (
        <div className="row sort-row display-flex ltr">
          {items.map((value, index) => (
            <SortableItem key={value.id} index={index} value={value} />
          ))}
        </div>
      )
    })

    const { data } = this.state

    return (
      <div>
        <SortableList
          items={data}
          onSortEnd={this.onSortEnd}
          axis="xy"
          shouldCancelStart={this.shouldCancelStart}
          //  helperContainer={() => (<div className="ui-sortable-helper"></div>)}
        />
        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={() => this.setState({ confirmDeleteShow: false })}
          onConfirm={() => this.handleConfirmDelete()}
          title={'آیا از حذف این تصویر مطمئن هستید؟'}
        />
      </div>
    )
  }
}
